import { ContainerOverlay } from 'components/Container/ContainerOverlay';
import GenericError from 'pages/Authorize/Errors/GenericError';
import { sanitizeHtml } from 'utils/sanitize-html';

export const CriticalAuthError = ({
  onButtonClick,
  headerText,
  errorMessage,
  formattedMessage,
  instructionsLink,
  buttonLabel,
}: {
  onButtonClick?: () => void;
  headerText?: string;
  errorMessage?: string;
  formattedMessage?: string;
  instructionsLink?: string;
  buttonLabel?: string;
}) => (
  <ContainerOverlay>
    <GenericError
      buttonLabel={buttonLabel}
      title={headerText || 'Something went wrong'}
      onClick={onButtonClick}
      instructionsLink={instructionsLink}
    >
      {formattedMessage && sanitizeHtml(formattedMessage).trim() ? (
        <span
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(formattedMessage) }}
        />
      ) : (
        errorMessage || 'An unexpected error occurred. Please try again.'
      )}
    </GenericError>
  </ContainerOverlay>
);
